import { MapPin } from "lucide-react";
import SeoLanding from "@/components/site/SeoLanding";

export default function AutoEcoleParis() {
  return (
    <SeoLanding
      testId="page-auto-ecole-paris"
      seo={{
        title: "Auto-école Paris · Permis B & Moto à 5 min de Paris 15/16 | DDSBillancourt",
        description: "Auto-école proche de Paris (15e, 16e, 7e) : permis B boîte auto 899 €, boîte manuelle 999 €, conduite 7j/7 de 7h à 22h, points de rendez-vous Porte de Saint-Cloud, Porte d'Auteuil et Place d'Italie. Agrément préfectoral, moniteurs pédagogues, e-learning inclus.",
        path: "/auto-ecole-paris",
      }}
      breadcrumbName="Auto-école Paris"
      badge="Paris · 15e / 16e / 7e · Boulogne 92100"
      badgeIcon={MapPin}
      h1="Auto-école proche de Paris : permis à 5 minutes du 15e et 16e"
      intro={[
        "Vous cherchez une auto-école à Paris ? DDSBillancourt (Dynastie Drive School) est installée à Boulogne-Billancourt (92100), à 5 minutes seulement de la Porte de Saint-Cloud et de la Porte d'Auteuil, directement accessible en ligne 9, tramway T2 et T3. Nous formons chaque année des centaines de Parisiens du 15e, 16e, 7e et 14e arrondissement — souvent moins chers et plus disponibles que les auto-écoles intra-muros.",
        "Notre approche : des moniteurs référents, une conduite disponible 7 jours sur 7 de 7h à 22h, un e-learning complet inclus et des points de rendez-vous directement dans Paris. Vous choisissez votre horaire, votre point de départ et votre pack — nous nous adaptons à votre emploi du temps parisien.",
      ]}
      formules={[
        {
          name: "Permis B boîte automatique · 13 leçons + 5 offertes",
          price: "899 €",
          priceNum: 899,
          highlight: true,
          features: [
            "13 leçons + 5 offertes sur véhicule automatique récent",
            "Rendez-vous possible Porte de Saint-Cloud / Auteuil",
            "Simulateur de conduite nouvelle génération",
            "Paiement en plusieurs fois sans frais",
          ],
        },
        {
          name: "Permis B boîte manuelle · 20 leçons",
          price: "999 €",
          priceNum: 999,
          features: [
            "20 heures de conduite (minimum légal)",
            "Livret d'apprentissage suivi par un moniteur référent",
            "Présentation à l'examen incluse",
          ],
        },
      ]}
      sections={[
        {
          title: "Pourquoi choisir une auto-école proche de Paris plutôt que dans Paris ?",
          paragraphs: [
            "Les auto-écoles parisiennes affichent souvent des tarifs 20 à 40 % plus élevés que la moyenne francilienne, avec des délais d'attente longs et des créneaux d'examen saturés. À l'inverse, DDSBillancourt bénéficie d'un centre d'examen moins engorgé (Rueil-Malmaison / Nanterre) tout en assurant vos leçons directement dans Paris intramuros.",
            "Résultat : un permis plus rapide à obtenir, à un tarif transparent, et une conduite dans les vraies conditions parisiennes (Porte Maillot, Trocadéro, Place d'Italie, quais de Seine…).",
          ],
          bullets: [
            { title: "Tarifs plus doux qu'à Paris", text: "à qualité de formation équivalente, économisez 200 à 500 € par rapport à une auto-école du 15e ou 16e arrondissement." },
            { title: "Examen plus rapide", text: "centre d'examen Rueil / Nanterre moins engorgé qu'Achères ou Saint-Denis, souvent utilisés par les écoles parisiennes." },
            { title: "Conduite dans Paris intramuros", text: "vos leçons se déroulent réellement dans le trafic parisien : Périph', Bois de Boulogne, Trocadéro, Champs-Élysées." },
            { title: "Métro & tram directs", text: "ligne 9 (Marcel Sembat), tramway T2 (Musée de Sèvres) et T3 (Porte de Sèvres) à 2 minutes du bureau." },
          ],
        },
        {
          title: "Nos points de rendez-vous dans Paris",
          paragraphs: [
            "Pour vous éviter tout trajet inutile, vos leçons peuvent démarrer directement dans Paris. Vous choisissez le point de rendez-vous qui vous arrange à la réservation :",
          ],
          bullets: [
            { title: "Porte de Saint-Cloud (Paris 16e)", text: "à la sortie du métro ligne 9, idéal pour les habitants d'Auteuil, Passy et Boulogne." },
            { title: "Porte d'Auteuil (Paris 16e)", text: "sortie du métro ligne 10, parfait pour circuler autour du Bois de Boulogne et de Roland-Garros." },
            { title: "Place d'Italie (Paris 13e)", text: "carrefour majeur pour les habitants du 13e, 14e et 5e arrondissement." },
            { title: "Bureau à Boulogne (92100)", text: "37 Av. Édouard Vaillant, à 5 minutes en métro du 16e arrondissement." },
          ],
        },
        {
          title: "Une auto-école pensée pour les Parisiens actifs",
          paragraphs: [
            "Étudiants du 15e, cadres du 8e, jeunes actifs du 11e, parents du 16e : nos élèves ont un point commun, un agenda chargé. C'est pourquoi nous ouvrons nos leçons de conduite de 7h à 22h du lundi au samedi, et de 10h à 20h le dimanche. Les leçons du soir entre 20h et 22h sont majorées de 5 € par heure — contactez le secrétariat au 01 41 31 50 61 pour toute question.",
            "Le code de la route se révise en illimité depuis votre canapé sur notre plateforme e-learning (36 cours + quiz interactifs), et vous pouvez venir passer des séances d'entraînement en salle sans rendez-vous.",
          ],
        },
        {
          title: "Quels arrondissements de Paris desservons-nous ?",
          paragraphs: [
            "Nos élèves parisiens viennent principalement du 15e, 16e, 7e, 8e, 14e et 13e arrondissement. Mais nous accueillons également les habitants du reste de Paris — nos horaires étendus et nos points de rendez-vous multiples permettent à n'importe quel Parisien de se former chez nous sans perdre de temps en trajet.",
          ],
          bullets: [
            { title: "Paris 15e", text: "Vaugirard, Convention, Beaugrenelle — 10 min en ligne 8 ou T3." },
            { title: "Paris 16e", text: "Auteuil, Passy, Trocadéro — 5 min en ligne 9 ou 10." },
            { title: "Paris 7e / 8e", text: "Invalides, Champ-de-Mars, Champs-Élysées — 15 min en ligne 9." },
            { title: "Paris 14e / 13e", text: "Montparnasse, Place d'Italie — point de rendez-vous direct Place d'Italie." },
            { title: "Paris 17e / 9e", text: "Batignolles, Opéra — 20 min en tram T3 ou RER C." },
          ],
        },
      ]}
      faq={[
        { q: "Vous êtes une auto-école à Paris ?", a: "Notre agrément est à Boulogne-Billancourt (92100), à la limite du 16e arrondissement de Paris, à 5 minutes de la Porte de Saint-Cloud. Vos leçons de conduite peuvent démarrer directement à Paris (Porte de Saint-Cloud, Porte d'Auteuil, Place d'Italie) — vous n'avez donc pas besoin de venir jusqu'au bureau pour votre formation pratique." },
        { q: "Puis-je passer mon examen à Paris ?", a: "Notre centre d'examen de rattachement est Rueil-Malmaison / Nanterre (Hauts-de-Seine), généralement moins saturé que les centres parisiens intra-muros. Vous obtiendrez ainsi votre permis plus rapidement, tout en ayant appris à conduire dans le vrai trafic parisien." },
        { q: "Combien coûte le permis quand on habite à Paris ?", a: "Chez DDSBillancourt, le permis B en boîte automatique est à 899 € (13 leçons + 5 offertes) et le permis B boîte manuelle à 999 € (20 heures). Aucun frais caché — comparez avec les tarifs des auto-écoles du 15e ou 16e, souvent 20 à 40 % plus chers." },
        { q: "Est-ce que je peux conduire dans Paris pendant mes leçons ?", a: "Oui, systématiquement. Nos moniteurs adaptent chaque leçon pour vous confronter aux conditions réelles de Paris : Périphérique, Champs-Élysées, quais de Seine, Trocadéro, Place d'Italie. C'est un atout majeur pour votre autonomie une fois le permis en poche." },
        { q: "Quelle est l'auto-école la plus proche de Paris 16 ?", a: "DDSBillancourt est très probablement l'auto-école la plus proche de la Porte de Saint-Cloud et de la Porte d'Auteuil : 5 minutes en métro (ligne 9), et nos points de rendez-vous se trouvent directement dans le 16e arrondissement." },
      ]}
      crossLinks={[
        { to: "/permis-boite-automatique", label: "Permis boîte automatique" },
        { to: "/permis-boite-manuelle", label: "Permis boîte manuelle" },
        { to: "/conduite-accompagnee", label: "Conduite accompagnée (AAC)" },
        { to: "/accelere", label: "Formations accélérées" },
        { to: "/code-de-la-route", label: "Code de la route en ligne" },
        { to: "/moto", label: "Permis moto" },
      ]}
    />
  );
}
